import { useQuery } from "react-query";

import type { UserSubscription } from "@jti/rest-api-types";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { SubscriptionsApi } from "../../../services";

export const GET_USER_SUBSCRIPTION_QUERY_KEY_BASE = QUERY_KEYS.userSubscription;

export const useUserSubscription = () => {
  const subscriptionsApi = SubscriptionsApi.init();

  return useQuery<UserSubscription>({
    queryKey: [QUERY_KEYS.userSubscription],
    queryFn: () => subscriptionsApi.getUserSubscription(),
    refetchOnMount: true,
    staleTime: 5000,
    retry: false,
  });
};
